(() => {
	const SECTION_SELECTOR = "[data-complete-look]";

	function initCompleteLook(section) {
		if (section.dataset.initialized === "true") return;
		section.dataset.initialized = "true";

		initCarousel(section);
		initProductForms(section);
		section.addEventListener("complete-look:card-changed", (event) => {
			initProductForms(event.target);
		});
	}

	function initCarousel(section) {
		const track = section.querySelector("[data-complete-look-track]");
		const prev = section.querySelector("[data-complete-look-prev]");
		const next = section.querySelector("[data-complete-look-next]");
		const navigation = section.querySelector("[data-complete-look-navigation]");

		if (!track || !prev || !next) return;

		function updateArrows() {
			const maxScroll = track.scrollWidth - track.clientWidth;

			prev.disabled = maxScroll <= 2;
			next.disabled = maxScroll <= 2;
			if (navigation) navigation.hidden = maxScroll <= 2;
		}

		function scroll(direction) {
			const maxScroll = track.scrollWidth - track.clientWidth;
			if (direction > 0 && track.scrollLeft >= maxScroll - 2) {
				track.scrollTo({ left: 0, behavior: "smooth" });
				return;
			}
			if (direction < 0 && track.scrollLeft <= 2) {
				track.scrollTo({ left: maxScroll, behavior: "smooth" });
				return;
			}
			const card = track.querySelector(".complete-look-card");
			if (!card) return;

			const styles = window.getComputedStyle(track);
			const gap = parseFloat(styles.columnGap) || 0;
			const distance = card.getBoundingClientRect().width + gap;

			track.scrollBy({
				left: distance * direction,
				behavior: "smooth",
			});
		}

		prev.addEventListener("click", () => scroll(-1));
		next.addEventListener("click", () => scroll(1));

		track.addEventListener("scroll", updateArrows, {
			passive: true,
		});

		window.addEventListener("resize", updateArrows);
		updateArrows();
	}

	function initProductForms(section) {
		const forms = section.querySelectorAll("[data-complete-look-form]");

		forms.forEach((form) => {
			const select = form.querySelector("[data-look-variant]");
			const button = form.querySelector("[data-look-add]");
			const label = form.querySelector("[data-look-add-label]");
			const card = form.closest(".complete-look-card");
			const message = card.querySelector("[data-look-message]");
			const price = card.querySelector("[data-look-price]");

			const initialPriceMarkup = price?.innerHTML || "";
			const initialLabel = label?.textContent.trim() || "";

			function updateSelection() {
				if (!select || select.tagName !== "SELECT") return;

				const option = select.selectedOptions[0];

				if (option && option.value && option.dataset.price) {
					price.innerHTML = `<span>${option.dataset.price}</span>`;
				} else if (price) {
					price.innerHTML = initialPriceMarkup;
				}

				message.textContent = "";
				message.classList.remove("is-error", "is-success");
			}

			select?.addEventListener("change", updateSelection);

			form.addEventListener("submit", async (event) => {
				event.preventDefault();

				const variantId = select?.value;

				if (!variantId) {
					message.textContent = card.dataset.lookSelectVariant;
					message.classList.add("is-error");
					return;
				}

				button.disabled = true;
				button.classList.add("is-loading");
				label.textContent = card.dataset.lookAdding;
				message.textContent = "";
				message.classList.remove("is-error", "is-success");

				try {
					const root = window.Shopify?.routes?.root || "/";
					const response = await fetch(`${root}cart/add.js`, {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							Accept: "application/json",
						},
						body: JSON.stringify({
							items: [
								{
									id: Number(variantId),
									quantity: 1,
								},
							],
						}),
					});

					const result = await response.json();

					if (!response.ok) {
						throw new Error(result.description || result.message || card.dataset.lookError);
					}

					message.textContent = card.dataset.lookAdded;
					message.classList.add("is-success");
					label.textContent = card.dataset.lookAdded;

					document.dispatchEvent(
						new CustomEvent("complete-look:cart-added", {
							detail: {
								variantId: Number(variantId),
								response: result,
							},
						})
					);
				} catch (error) {
					message.textContent = error.message || card.dataset.lookError;
					message.classList.add("is-error");
					label.textContent = initialLabel;
				} finally {
					button.disabled = false;
					button.classList.remove("is-loading");

					if (message.classList.contains("is-success")) {
						label.textContent = initialLabel;
					}
				}
			});
		});
	}

	function initialize(root = document) {
		if (root.matches?.(SECTION_SELECTOR)) {
			initCompleteLook(root);
		}

		root.querySelectorAll(SECTION_SELECTOR).forEach(initCompleteLook);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", () => initialize());
	} else {
		initialize();
	}

	document.addEventListener("shopify:section:load", (event) => {
		initialize(event.target);
	});
})();
